module.exports = __webpack_public_path__ + "img/menu-reservation.cc8186e5.svg";